var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.modal,{ref:"drawerImageModal",tag:"component",staticClass:"drawer-image-modal",attrs:{"image":_vm.isPDF ? _vm.invoice.image : ''}})
}
var staticRenderFns = []

export { render, staticRenderFns }